import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LANGUAGE } from './app/constants/app-constants';
import LOCALES from './app/constants/locale-constants';

const languages = Object.values(LOCALES).map((locale) => ({
  key: locale,
  path: import(`./locales/${locale}`),
}));

async function configureI18n() {
  const resources = {};
  await Promise.all(languages.map(async (language) => {
    const lang = await language.path;
    resources[language.key] = {};
    resources[language.key].translation = lang.translations;
  }));

  i18n
    .use(initReactI18next)
    .init({
      lng: DEFAULT_LANGUAGE,
      fallbackLng: DEFAULT_LANGUAGE,
      resources,
      interpolation: {
        escapeValue: false,
      },
      react: {
        useSuspense: false, //   <---- this will do the magic
      },
    });
}

configureI18n();

export default i18n;
